
const messageHandler = (event) => {
	console.log('received windows event  ' + event.data); //windows event structure puts user data into the .data field

	//Windows sends boolean messages in event.data
	if (typeof event.data == 'boolean') {
		if (event.data) {
			//true means browser is ready. For JLL SS1 the UE app is not spawned so we can directly try to contact it
			xrsendConnectRequest();
		}
	}
};


//window.addEventListener('message', messageHandler); //listen for the raw message

var xrconnectedState = false;
var xrconnectTimer;

function xrsendConnectRequest() {
	let descriptor = { status: 'just to show we can' };
	let connectrq = { type: 'request', cmd: 'connect', msg: descriptor };
	console.log('Sending connect request');
	sendToStreamer(connectrq);
	console.log('Sent connect request. Starting timer.');
	xrconnectTimer = setTimeout(checkConnectStatus, 2000);
}

function xrsendChangeResolution(WxHf) {
	let descriptor = { console: `r.setRes ${WxHf}` };
	let connectrq = { type: 'notif', cmd: 'console', msg: descriptor };
	console.log(`Sending request to Encoder for new resolution ${WxHf}`);
	// if (webRtcPlayerObj.aggregatedStats.frameWidth && webRtcPlayerObj.aggregatedStats.frameHeight) {
	// 	console.log(
	// 		`Current stream resolution is ${webRtcPlayerObj.aggregatedStats.frameWidth}x${webRtcPlayerObj.aggregatedStats.frameHeight}`,
	// 	);
	// }
	sendToStreamer(connectrq);
}

function xrsendBitrateRequest(newrateKB) {
	let descriptor = { console: `PixelStreaming.Encoder.TargetBitrate ${newrateKB}` };
	let connectrq = { type: 'notif', cmd: 'console', msg: descriptor };
	console.log(`Sending request to Encoder for bitrate ${newrateKB}KB/s`);
	sendToStreamer(connectrq);
}

function checkConnectStatus() {
	if (!xrconnectedState) {
		console.log('Try connect request again');
		xrsendConnectRequest();
	} else clearTimeout(xrconnectTimer);
}
